<template>
  <sl-page>
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="8" :lg="8" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.name" placeholder="请输入名称进行搜索"></Input>
        </Col>
        <Col span="16" :lg="16" :md="16" :sm="12" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        <div>
          <Button type="primary" icon="md-add" @click="create()">新增</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
    </div>
    <car-log-item ref="item" @on-update="handleUpdate" />
  </sl-page>
</template>
<script>
import carLogItem from './detail'

const columns_ = [{
    type: 'index',
    width: 65,
    title: '序号',
    align: 'center'
  },
  {
    title: '设备ID',
    key: 'carId'
  },
  {
    title: '所属网点',
    key: 'companyName'
  },
  {
    title: '用户',
    key: 'courierName'
  },
  {
    title: '联系方式',
    key: 'courierPhone'
  },
  {
    title: '开始时间',
    key: 'startDatetimeText'
  },
  {
    title: '结束时间',
    key: 'endDatetimeText'
  },
  {
    title: '状态',
    key: 'stateText'
  }
]


export default {
  components: { carLogItem },
  data() {
    return {
      columns: [
        ...columns_,
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '查看'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params)
                  }
                }
              }, '删除')
            ])
          }
        }
      ],
      data: [],
      params: {
        name: null,
        code: null,
        contact: null,
        contactPhone: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    }
  },
  created() {
    this.def = { ...this.params }
    this.list()
  },

  methods: {
    $search(options){
      this.$utils.fill(this.params , options)
      this.list()
    },
    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.carLogs(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], {'startDatetime':'datetime','endDatetime':'datetime','state': '$carUseState'})
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.carLogDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    toggle({ row }) {

    },

    reset() {
      this.$utils.fill(this.params, this.def)
      console.log(this.params)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    }
  }
}

</script>
